import axios from 'axios'
import {AuthModel, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token.php`
export const LOGIN_URL = `${API_URL}/login.php`
export const REGISTER_URL = `${API_URL}/register.php`
export const CHECK_PHONE_NUL_URL = `${API_URL}/check_phone_num.php`

export const REQUEST_PASSWORD_URL = `${API_URL}/forget_ok.php`

// Server should return AuthModel
export function login(phonenum: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    phonenum,
    password,
  })
}

// Server should return AuthModel
export function register(
  // 호출하는 곳의 함수 순서를 맞춰야 함
  phonenum: string,  
  username: string,  
  email: string,
  password: string,    
) {
  return axios.post(REGISTER_URL, {
    phonenum,
    username,
    email,
    password,
  })
}

export function checkPhoneNum(
  phonenum: string | undefined,
){
  return axios.post(CHECK_PHONE_NUL_URL, {
    phonenum
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}
